import { useI18n } from "@/app/composables/useI18n"
import { computed, ref } from "vue"

export function useTooltip() {
  const { t } = useI18n()
  const tooltipVisible = ref<boolean>(false)
  const tooltipPosition = ref<{ x: number, y: number }>({ x: 0, y: 0 })
  const currentTooltipTarget = ref<"deposit" | "expand" | "collapse" | "buy-crypto" | "">("")

  function updateTooltipPosition(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement | null
    if (!target)
      return

    const rect = target.getBoundingClientRect()
    tooltipPosition.value = {
      x: rect.right,
      y: rect.top + rect.height / 2,
    }

    if (target.closest(".deposit-btn")) {
      currentTooltipTarget.value = "deposit"
    }
    else if (target.closest(".buy-crypto-btn")) {
      currentTooltipTarget.value = "buy-crypto"
    }
    else if (target.closest(".expand-btn-inner")) {
      currentTooltipTarget.value = "expand"
    }
    else {
      currentTooltipTarget.value = "collapse"
    }

    tooltipVisible.value = true
  }

  function hideTooltip() {
    tooltipVisible.value = false
  }

  const getTooltipText = computed(() => {
    switch (currentTooltipTarget.value) {
      case "deposit":
        return t("finance.deposit")
      case "expand":
        return t("general.expand")
      case "collapse":
        return t("general.collapse")
      case "buy-crypto":
        return t("finance.buy_crypto")
      default:
        return ""
    }
  })

  return {
    tooltipVisible,
    tooltipPosition,
    updateTooltipPosition,
    hideTooltip,
    getTooltipText,
  }
}
